"use client"

import { useState, useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";

export const useFetchRefinements = (groupId) => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { getAccessTokenSilently } = useAuth0();
  const apiUrl = process.env.REACT_APP_API_URL;

  useEffect(() => {
    const fetchItems = async () => {
      if (!groupId) return;
      try {
        const token = await getAccessTokenSilently({
          authorizationParams: {
            audience: process.env.REACT_APP_API_AUDIENCE,
          },
        });
        const response = await fetch(`${apiUrl}/api/GroupsTbls/${groupId}/refinements`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        if (!response.ok) {
          throw new Error("Failed to fetch refinements");
        }
        const data = await response.json();
        setItems(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchItems();
  }, [groupId, getAccessTokenSilently, apiUrl]);

  return { items, loading, error };
};
